import React, { useEffect } from "react";
import {
  InputGroup,
  Form,
  Container,
  Row,
  Col,
  Badge,
  Card,
  Table,
  Popover,
  OverlayTrigger,
  Button,
  Accordion,
  ListGroup,
} from "react-bootstrap";
import styles from "./CandidateDashBoard.module.css";
import TimeLinePicker from "../../../containers/TimeLinePicker/TimeLinePicker";
import { getDashboardByTimePeriod } from "../../../Slices/candidateSlice";
import { useSelector, useDispatch } from "react-redux";
import AggregatedTable from "../../../components/AggregatedTable/AggregatedTable";
// import { useHistory } from "react-router-dom";
import Loading from "./../../../components/Loading/Loading";

// Bootstrap CSS

import "bootstrap/dist/css/bootstrap.min.css";

// To make rows collapsible

import "bootstrap/js/src/collapse.js";

const CandidateDashBoard = () => {
  const controller = new AbortController();

  //#region Selectors
  // const fromDate = useSelector((state) => state.timeline.fromDate);
  // const toDate = useSelector((state) => state.timeline.toDate);
  // const fromTime = useSelector((state) => state.timeline.fromTime);
  // const toTime = useSelector((state) => state.timeline.toTime);
  // const history = useHistory();

  //#region Store Listeners
  const {
    fromDate,
    toDate,
    sessionUser,
    sessionUser: { timezone }
  } = useSelector((state) => state.sessionSlice);
  // const { dashboardData } = useSelector((state) => state.candidateSlice);
  //#endregion

  const dispatch = useDispatch();

  useEffect(() => {
    if (fromDate && toDate && Boolean(sessionUser)) {
      dispatch(
        getDashboardByTimePeriod({
          fromDate: fromDate,
          toDate: toDate,
          userId: sessionUser._id,
          timezone,
        })
      );
    }

    return () => {
      controller.abort();
    };
  }, [controller, dispatch, fromDate, sessionUser, toDate, timezone]);

  if (!sessionUser) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      <Container fluid={"lg"}>
        <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded"}>
          <TimeLinePicker />
        </Row>
        <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded"}>
          <AggregatedTable />
        </Row>
      </Container>
    </>
  );
};

export default CandidateDashBoard;
